<template>
  <div class="deposited">
    <div class="row">
      <template v-if="currentDeposit.account && currentDeposit.matched > 0">
        <div :class="leftColClassModifiers">
          <div class="deposited__title deposited__title--small">Transferred</div>
          <div class="deposited__amount deposited__amount--small" v-html="amountFormatted"></div>
        </div>
        <div class="small-4 column deposited__divider" v-if="hasPromotionalCredit">
          <div class="deposited__title deposited__title--small">
            <template v-if="isLayoutDesktop"> Promotional Credit </template>
            <template v-else> Credit </template>
          </div>
          <div class="deposited__amount deposited__amount--small" v-html="matchedFormatted"></div>
        </div>
        <div :class="rightColClassModifiers">
          <div class="deposited__title deposited__title--small">Available</div>
          <div class="deposited__amount deposited__amount--small">{{ balance.accountBalance }}</div>
        </div>
      </template>
      <template v-else>
        <div :class="leftColClassModifiers">
          <div class="deposited__title deposited__title--small">Deposited</div>
          <div class="deposited__amount deposited__amount--small" v-html="amountFormatted"></div>
        </div>
        <div class="small-4 column deposited__divider" v-if="hasPromotionalCredit">
          <div class="deposited__title deposited__title--small">
            <template v-if="isLayoutDesktop"> Promotional Credit </template>
            <template v-else> Credit </template>
          </div>
          <div
            class="deposited__amount deposited__amount--small"
            v-html="promoAmountFormatted"
          ></div>
        </div>
        <div :class="rightColClassModifiers">
          <div class="deposited__title deposited__title--small">Available</div>
          <div class="deposited__amount deposited__amount--small">{{ balance.accountBalance }}</div>
        </div>
      </template>
      <div
        class="column small-12"
        v-if="currentDeposit.account || currentDeposit.confirmationNumber"
      >
        <div
          v-if="currentDeposit.account"
          class="deposited__confirmation-number"
          v-html="currentDeposit.messageForUser"
        ></div>
        <div class="deposited__confirmation-number" v-else>
          Your confirmation number for this transaction is {{ currentDeposit.confirmationNumber }}.
        </div>
      </div>
      <div class="column small-12" v-if="currentDeposit.account">
        <bank-account class="deposited__account" :preview="true" :account="currentDeposit.account">
        </bank-account>
      </div>
    </div>
  </div>
</template>

<script src="./deposited.js"></script>
<style src="./deposited.scss" lang="scss"></style>
